import { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  requiredDate: "",
  productType: "",
  size: "",
  quantity: "",
  flavor: "",
  message: "",
};

export const ContactFormModal = ({
  isOpen,
  onClose,
  contactData,
  flavorsData,
}) => {
  const [formData, setFormData] = useState(initialState);
  const [status, setStatus] = useState({ type: "", message: "" });

  // Get unique flavors from flavorsData
  const getUniqueFlavors = () => {
    if (!flavorsData) return [];
    const flavors = flavorsData.map((item) => item.name);
    return [...new Set(flavors)];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => {
      const newState = { ...prevState, [name]: value };
      // Reset size and quantity when product type changes
      if (name === "productType") {
        if (value !== "Cake" && value !== "Cupcakes") {
          newState.size = "";
        }
        if (value !== "Cupcakes") {
          newState.quantity = "";
        }
      }
      return newState;
    });
  };

  const clearState = () => setFormData({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    // EmailJS configuration
    const serviceId =
      process.env.REACT_APP_EMAILJS_SERVICE_ID || "YOUR_SERVICE_ID";
    const templateId =
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "YOUR_TEMPLATE_ID";
    const publicKey =
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "YOUR_PUBLIC_KEY";

    // If EmailJS is not configured, use mailto as fallback
    if (
      serviceId === "YOUR_SERVICE_ID" ||
      templateId === "YOUR_TEMPLATE_ID" ||
      publicKey === "YOUR_PUBLIC_KEY"
    ) {
      // Fallback to mailto link
      const subject = encodeURIComponent("Cake Request");
      const body = encodeURIComponent(
        `Name: ${formData.name}\nEmail: ${formData.email}\nRequired Date: ${
          formData.requiredDate
        }\nProduct Type: ${formData.productType}\n${
          formData.size ? `Size: ${formData.size}\n` : ""
        }${formData.quantity ? `Quantity: ${formData.quantity}\n` : ""}${
          formData.flavor ? `Flavor: ${formData.flavor}\n` : ""
        }\nMessage:\n${formData.message}`
      );
      window.location.href = `mailto:tanyaartcake.ca@gmail.com?subject=${subject}&body=${body}`;
      setStatus({
        type: "info",
        message: "Opening your email client...",
      });
      clearState();
      return;
    }

    // Send email using EmailJS
    emailjs.sendForm(serviceId, templateId, e.target, publicKey).then(
      (result) => {
        console.log(result.text);
        setStatus({
          type: "success",
          message: "Thank you! Your request has been sent successfully.",
        });
        clearState();
        setTimeout(() => {
          onClose();
        }, 2000);
      },
      (error) => {
        console.log(error.text);
        setStatus({
          type: "error",
          message:
            "Sorry, there was an error sending your request. Please try again or email us directly.",
        });
      }
    );
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const uniqueFlavors = getUniqueFlavors();
  const showSizeField =
    formData.productType === "Cake" || formData.productType === "Cupcakes";
  const showQuantityField = formData.productType === "Cupcakes";

  return (
    <div
      className="contact-modal-overlay"
      onClick={handleBackdropClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}
    >
      <div
        className="contact-modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#123c69",
          borderRadius: "12px",
          padding: "40px",
          maxWidth: "600px",
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "15px",
            right: "15px",
            background: "transparent",
            border: "none",
            color: "#fff",
            fontSize: "28px",
            cursor: "pointer",
            width: "35px",
            height: "35px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.target.style.background = "rgba(255, 255, 255, 0.1)")
          }
          onMouseLeave={(e) => (e.target.style.background = "transparent")}
        >
          ×
        </button>
        <div className="section-title" style={{ textAlign: "left" }}>
          <h2 style={{ color: "#fff", marginTop: "0", textAlign: "left" }}>
            Request
          </h2>
          <div
            style={{
              height: "4px",
              width: "60px",
              background: "#ac3b61",
              marginTop: "15px",
              marginBottom: "20px",
            }}
          ></div>
          <p style={{ color: "rgba(255, 255, 255, 0.75)", fontSize: "18px" }}>
            Please fill out the form below and I will get back to you as soon as
            possible.
          </p>
        </div>
        <form name="sentMessage" validate onSubmit={handleSubmit}>
          <input
            type="hidden"
            name="to_email"
            value="tanyaartcake.ca@gmail.com"
          />
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <input
                  type="text"
                  id="modal-name"
                  name="name"
                  className="form-control"
                  placeholder="Name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                />
                <p className="help-block text-danger"></p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <input
                  type="email"
                  id="modal-email"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
                <p className="help-block text-danger"></p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <input
                  type="text"
                  id="modal-required-date"
                  name="requiredDate"
                  className="form-control"
                  placeholder="Required Date"
                  required
                  value={formData.requiredDate}
                  onChange={handleChange}
                />
                <p className="help-block text-danger"></p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <select
                  id="modal-product-type"
                  name="productType"
                  className="form-control"
                  required
                  value={formData.productType}
                  onChange={handleChange}
                  style={{
                    color: formData.productType === "" ? "#ac3b61" : "#333",
                  }}
                >
                  <option value="" disabled>
                    Select Dessert Type
                  </option>
                  <option value="Cake">Cake</option>
                  <option value="Cupcakes">Cupcakes</option>
                  <option value="3D Cake">3D Cake</option>
                </select>
                <p className="help-block text-danger"></p>
              </div>
            </div>
          </div>
          {showSizeField && (
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <select
                    id="modal-size"
                    name="size"
                    className="form-control"
                    required={showSizeField}
                    value={formData.size}
                    onChange={handleChange}
                    style={{
                      color: formData.size === "" ? "#ac3b61" : "#333",
                    }}
                  >
                    <option value="" disabled>
                      Select Size
                    </option>
                    {formData.productType === "Cake" && (
                      <>
                        <option value="Bento Cake (4 inch)">
                          Bento Cake (4")
                        </option>
                        <option value="Small (6 inch)">Small (6")</option>
                        <option value="Medium (7 inch)">Medium (7")</option>
                        <option value="Large (8 inch)">Large (8")</option>
                      </>
                    )}
                    {formData.productType === "Cupcakes" && (
                      <>
                        <option value="Small">Small</option>
                        <option value="Regular">Regular</option>
                      </>
                    )}
                  </select>
                  <p className="help-block text-danger"></p>
                </div>
              </div>
            </div>
          )}
          {showQuantityField && (
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <input
                    type="number"
                    id="modal-quantity"
                    name="quantity"
                    className="form-control"
                    placeholder="Quantity"
                    required={showQuantityField}
                    min="1"
                    value={formData.quantity}
                    onChange={handleChange}
                  />
                  <p className="help-block text-danger"></p>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <select
                  id="modal-flavor"
                  name="flavor"
                  className="form-control"
                  value={formData.flavor}
                  onChange={handleChange}
                  style={{
                    color: formData.flavor === "" ? "#ac3b61" : "#333",
                  }}
                >
                  <option value="" disabled>
                    Select Flavor (Optional)
                  </option>
                  {uniqueFlavors.map((flavor, index) => (
                    <option key={index} value={flavor}>
                      {flavor}
                    </option>
                  ))}
                </select>
                <p className="help-block text-danger"></p>
              </div>
            </div>
          </div>
          <div className="form-group">
            <textarea
              name="message"
              id="modal-message"
              className="form-control"
              rows="4"
              placeholder="Describe your dream dessert"
              required
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            <p className="help-block text-danger"></p>
          </div>
          {status.message && (
            <div
              className={`alert ${
                status.type === "success"
                  ? "alert-success"
                  : status.type === "error"
                  ? "alert-danger"
                  : "alert-info"
              }`}
              style={{
                marginTop: "15px",
                padding: "12px 16px",
                borderRadius: "8px",
                backgroundColor:
                  status.type === "success"
                    ? "#d4edda"
                    : status.type === "error"
                    ? "#f8d7da"
                    : "#d1ecf1",
                color:
                  status.type === "success"
                    ? "#155724"
                    : status.type === "error"
                    ? "#721c24"
                    : "#0c5460",
                border:
                  status.type === "success"
                    ? "1px solid #c3e6cb"
                    : status.type === "error"
                    ? "1px solid #f5c6cb"
                    : "1px solid #bee5eb",
              }}
            >
              {status.message}
            </div>
          )}
          <button type="submit" className="btn btn-custom btn-lg">
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};
